// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1v6uo","bigColWidth":"Table_bigColWidth__3yBhv","biggerColWidth":"Table_biggerColWidth__1qpJk","row":"Table_row__16WVD","col":"Table_col__2zZi4"};